import React, { useMemo, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@material-ui/styles";
import { InputAdornment, ListSubheader, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { containsText } from "../CommonFunctions";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};
const MenuPropsWidth = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxWidth: 400,
    },
  },
};

const usestyles = makeStyles({
  formControlStyle: {
    "& .MuiInputBase-root.Mui-disabled": {
      background: "#F6F6F6",
    },
  },
});

export default function MultiSelectCheckFilter(props) {
  const {
    filters,
    setFilters,
    multipleFlag,
    id,
    options,
    placeholder,
    subPlaceholder,
    uniqueKey,
    disabled,
  } = props;

  const classes = usestyles();
  const [selectedNames, setSelectedNames] = useState(
    filters[id].length === 0 ? [placeholder] : filters[id]
  );
  const [searchText, setSearchText] = useState("");

  const renderValue = (selected) => {
    if (
      selected.length === 0 ||
      (selected.length === 1 && selected[0] === placeholder)
    ) {
      return (
        <div
          style={{
            opacity:
              uniqueKey === "action_addMember" ||
              uniqueKey === "action_viewMember" ||
              uniqueKey === "dashboardPages_addMember" ||
              uniqueKey === "dashboardPages_viewMember" ||
              uniqueKey === "projects_addMember" ||
              uniqueKey === "projects_viewMember"
                ? "0.5"
                : "1",
          }}
        >
          {placeholder}
        </div>
      );
    }

    let selectedValues = options
      .filter((option) => selected.includes(option.name))
      .map((option) => option.name)
      .join(", ");

    return selectedValues;
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    let mainValue =
      value === "string"
        ? value.split(",").filter((e) => e !== placeholder)
        : value.filter((e) => e !== placeholder);

    const disFilter = mainValue.map(
      (val) => options.find((op) => op.name === val)?.id
    );

    setFilters({
      ...filters,
      [id]: disFilter,
    });

    setSelectedNames(mainValue.length ? mainValue : [placeholder]);
  };

  const displayedOptions = useMemo(
    () =>
      uniqueKey === "projects_addMember" || uniqueKey === "projects_viewMember"
        ? options.filter((option) => containsText(option.name, searchText))
        : options,
    [uniqueKey, searchText, options]
  );

  return (
    <FormControl
      variant="outlined"
      sx={{ width: "95%" }}
      disabled={disabled}
      className={`${
        uniqueKey === "action_addMember" ||
        uniqueKey === "action_viewMember" ||
        uniqueKey === "dashboardPages_addMember" ||
        uniqueKey === "dashboardPages_viewMember" ||
        uniqueKey === "projects_addMember" ||
        uniqueKey === "projects_viewMember"
          ? classes.formControlStyle
          : ""
      }`}
    >
      <Select
        multiple={multipleFlag}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        options={options}
        value={selectedNames.length ? selectedNames : []}
        onChange={handleChange}
        style={{
          height: "40px",
        }}
        renderValue={renderValue}
        MenuProps={
          uniqueKey === "action_addMember"
            ? MenuProps
            : uniqueKey === "projects_addMember" ||
              uniqueKey === "projects_viewMember"
            ? MenuPropsWidth
            : {
                ...MenuProps,
                anchorOrigin: {
                  vertical: "top", // Dropdown will anchor from the top
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "bottom", // Dropdown will open upwards
                  horizontal: "left",
                },
              }
        }
      >
        {/* TextField is put into ListSubheader so that it doesn't act as a selectable item in the menu.
          i.e. we can click the TextField without triggering any selection.*/}
        <ListSubheader>
          {(uniqueKey === "projects_addMember" ||
            uniqueKey === "projects_viewMember") && (
            <TextField
              size="small"
              autoFocus // Autofocus on textfield
              placeholder={subPlaceholder}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          )}
        </ListSubheader>

        {displayedOptions.map((option) => (
          <MenuItem
            key={option.id}
            value={option.name}
            style={{
              padding: "0",
              textWrap:
                uniqueKey === "projects_addMember" ||
                uniqueKey === "projects_viewMember"
                  ? "auto"
                  : "",
            }}
            disabled={
              (uniqueKey === "action_addMember" ||
                uniqueKey === "action_viewMember") &&
              option.label === 1
            }
          >
            <Checkbox checked={selectedNames.indexOf(option.name) > -1} />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
